const scriptId = 'revieve_script';
const scriptSrc = 'https://d38knilzwtuys1.cloudfront.net/revieve-plugin-v4/revieve-plugin-loader.js';

export { scriptId, scriptSrc };
